export const SHARE_LINK_EXPIRATION_TIME_SECONDS = 4 * 60 * 60;
//# sourceMappingURL=share-replay.js.map